<template>
  <div class="schedule-page">
    <img class="banner" src="../../../assets/images/schedule/banner.png" alt="">
    <van-empty v-show="showEmpty">
      暂无行程
      <template #image>
        <img class="empty-image" src="../../../assets/images/common/empty.png" alt="no-jobs">
      </template>
    </van-empty>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="list.length!==0 ? finishedText : ''"
      :error.sync="error"
      :error-text="errorText"
      loading-text="加载中..."
      @load="onLoad"
      class="schedule-list"
    >
      <div v-for="schedule in list" :key="schedule.id" class="schedule-item" @click="toDetail(schedule.id)">
        <img class="school-logo" :src="schoolIcon(schedule.cover_image)" alt="">
        <div class="schedule-detail">
          <b>
            <span class="school-name">{{schedule.school_name}}</span>
            <van-tag class="schedule-tag" :class="scheduleStatus(schedule.progress_status).type">{{scheduleStatus(schedule.progress_status).label}}</van-tag>
          </b>
          <p>时间：{{ preach_begintime(schedule.preach_begintime) }}</p>
          <p>地址：{{schedule.address}}</p>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>

import  filters  from '@/filters'
import util from "../../../libs/util";

const statusList = [
  {
    status:'NotStart',
    type:'before-start',
    label:'未开始'
  },
  {
    status:'OnGoing',
    type:'doing',
    label:'进行中'
  },
  {
    status:'End',
    type:'over',
    label:'已结束'
  },
  {
    status:'ComingSoon',
    type:'before-start',
    label:'未开始'
  }
]
export default {
  name: 'ScheduleList',
  data() {
    return {
      errorText: "网络开小差了，点击重新加载",
      error: false,
      loading:false,
      finished:false,
      page:1,
      list:[]
    };
  },
  computed: {
    showEmpty() {
      return !this.error && !this.loading && this.list.length === 0;
    },
    finishedText() {
      return this.list.length === 0 ? "" : "— 到底咯！—";
    },
  },
  created(){
    this.getSchedule()
    const shareParam = {
      title: "加入我们，实现价值",
      desc: "卫宁健康2027校园招聘",
        link: process.env.VUE_APP_BASEURL +'#/schedule/list',
      imgUrl: process.env.VUE_APP_SHARE_IMG_URL
    }
    util.initWXSdk(shareParam)
  },
  methods: {
    schoolIcon(id){
      return `${process.env.VUE_APP_IMAGE_URL}/file?id=${id}`
    },
    preach_begintime(val){
      return val && filters.formatDateTime(val) || '敬请期待'
    },
    getSchedule(){
      this.loading = true
      const params = {
        page:this.page
      }
      this.$api.RECRUIT_TRIP_LIST(params).then(res =>{
        this.loading = false;
        this.list = this.list.concat(res.content);
        if(this.list.length == res.total){
          this.finished = true
        }
        this.error = false;
      })
      .catch(() => {
        this.error = true;
        this.page -= 1;
      })
      .finally(() => {
        this.loading = false;
      });
    },
    onLoad() {
      this.page += 1
      this.getSchedule()
    },
    scheduleStatus(value) {
      const status =  statusList.filter(item => item.status === value)
      try {
        return status[0]
      } catch (error) {
        return {}
      }
    },
    toDetail(scheduleId) {
      this.$router.push({
        name: 'ScheDuleDetail',
        params: {
          id: scheduleId
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
  .schedule-page {
    text-align: left;
    height: calc(100vh - 54px);
    overflow-y: scroll;
  }
  img.banner{
    display:block;
    width:100%;
    background:#2E5DD2;
  }

  .schedule-item{
    margin:0 20px;
    padding:14px 0;
    border-bottom:1px solid #F1F4F6;
    display: flex;
  }

  .school-logo{
    float:left;
    width:60px;
    height:60px;
    // border-radius:100%;
    margin-right:16px;
  }
  .school-name{
    display: -webkit-box;
    max-width: 191px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .schedule-detail{
    width: 100%;
    b{
      color:#333;
      font-size:18px;
      line-height:25px;
      display:flex;
      justify-content: space-between;
    }
  }

  .schedule-item p{
    width: 259px;
    margin:0;
    font-size:12px;
    line-height:17px;
    color:#999;
    margin-top:2px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  .schedule-tag{
    // display:block;
    width:52px;
    height:22px;
    font-size:12px;
    color:#666;
    text-align: center;
    // line-height:22px;
    padding:0;
    background: linear-gradient(90deg, #F5F5F5 1%, #F0F0F0 99%);
    border-radius: 4px;
    font-weight: normal;
  }
  .schedule-tag.before-start{
    color:#fff;
    background: linear-gradient(90deg, #3871FF 0%, #2E5DD2 100%);
  }

  .schedule-tag.doing {
    color:#fff;
    background: linear-gradient(90deg, #FF9900 0%, #FF8D19 24%, #FE6868 100%);
  }

  ::v-deep {
    .van-list__finished-text {
      color: #cccccc;
    }
  }
</style>
